<!-- 秒,分钟,小时通用组件 -->
<template>
  <div class="second-minute-hour-box">
    <RadioGroup @on-change="getValue" size="small" style="width: 100%" v-model="type">
      <!-- 每* -->
      <div class="box-bottom">
        <Radio border label="1" size="small">每{{lable}}</Radio>
      </div>
      <!-- 每个周期 -->
      <div class="box-bottom cycle">
        <Radio border label="2" size="small">周期</Radio>
        <template v-if="type == '2'">
          <span style="margin-right:0.5rem;">从</span>
          <InputNumber
            :max="maxTime - 1"
            :min="1"
            @on-change="getChangeTime"
            size="small"
            style="width: 4rem;"
            v-model="cycle.start"
          ></InputNumber>
          <span style="margin:0 0.5rem;">至</span>
          <InputNumber
            :max="maxTime"
            :min="parseInt(cycle.start) + 1"
            @on-change="getChangeTime"
            size="small"
            style="width: 4rem;"
            v-model="cycle.end"
          ></InputNumber>
          <span style="margin-left:0.5rem;">{{lable}}</span>
        </template>
      </div>
      <!-- 每个循环 -->
      <div class="box-bottom cycle">
        <Radio border label="3" size="small">循环</Radio>
        <template v-if="type == '3'">
          <span style="margin-right:0.5rem;">从</span>
          <InputNumber
            :max="maxTime"
            :min="0"
            @on-change="getLoopTime"
            size="small"
            style="width: 4rem;"
            v-model="loop.start"
          ></InputNumber>
          <span style="margin:0 0.5rem;">{{lable}}开始，每</span>
          <InputNumber
            :max="maxTime"
            :min="1"
            @on-change="getLoopTime"
            size="small"
            style="width: 4rem;"
            v-model="loop.end"
          ></InputNumber>
          <span style="margin-left:0.5rem;">{{lable}}</span>执行一次
        </template>
      </div>
      <!-- 指定数 -->
      <div class="box-bottom">
        <Radio border label="4" size="small">指定</Radio>
        <Select
          @on-change="getAppointTime"
          multiple
          placeholder="请选择"
          size="small"
          style="width: auto"
          transfer
          v-if="type=='4'"
          v-model="appoint"
        >
          <Option :key="i-1" :label="(i-1)+lable" :value="i-1" v-for="i in appointNumber"></Option>
        </Select>
      </div>
      <div>
        <!-- <CheckboxGroup class="second-minute-chekck-group" v-model="appoint">
          <Checkbox
            :key="i-1"
            :label="i-1"
            @on-change="getAppointTime"
            v-for="i in appointNumber"
          >{{i-1}}</Checkbox>
        </CheckboxGroup>-->
      </div>
    </RadioGroup>
  </div>
</template>

<script>
export default {
  props: {
    // 传递的lable(时，分，秒),用于区分秒和分,必填
    lable: {
      type: String,
      requied: true
    }
  },
  data () {
    return {
      // 根据传递进来的lable值决定数值,秒分为60,时24
      appointNumber: this.lable == "时" ? 24 : 60,
      // 最大值
      maxTime: this.lable == "时" ? 23 : 59,
      // 类型
      type: "4",
      // 周期
      cycle: {
        start: 0,
        end: 0
      },
      // 循环
      loop: {
        start: 0,
        end: 0
      },
      appoint: ['0'], // 指定
      result: ""
    }
  },
  methods: {
    // 当前选择项
    getValue (value) {
      // 清空指定的选择项
      this.appoint = []
      if (value == "1") {
        // 指定每*
        this.result = "*"
      } else if (value == "2") {
        // 指定周期
        this.result = this.cycle.start + "-" + this.cycle.end
      } else if (value == "3") {
        // 指定循环
        this.result = this.loop.start + "/" + this.loop.end
      } else {
        // 指定日期-默认勾选0
        this.appoint = [0]
        this.result = this.appoint.join(",")
      }
      console.log("result", this.result)
      this.$emit("time", this.result)
    },
    // 选择周期
    getChangeTime () {
      this.type = "2"
      this.result = this.cycle.start + "-" + this.cycle.end
      console.log("result", this.result)
      this.$emit("time", this.result)
      // 清空指定状态
      this.appoint = []
    },
    // 选择循环
    getLoopTime () {
      this.type = "3"
      this.result = this.loop.start + "/" + this.loop.end
      console.log("result", this.result)
      this.$emit("time", this.result)
      // 清空指定状态
      this.appoint = []
    },
    // 选择指定
    getAppointTime () {
      this.type = "4"
      this.result = this.appoint
        .sort((a, b) => {
          return a - b
        })
        .join(",")
      console.log("result", this.result)
      this.$emit("time", this.result)
    }
  }
};
</script>

